export default "__VITE_ASSET__DQIRL1N0__"